import { platformMultiClientConfigForClient } from '../config/multi-client.config';
import { MultiClientConfigKey } from '../../common/types/multi-client.types';
import { PlatformMultiClientConfigForClient } from '../config/multi-client-config.types';

export const getMultiClientPlatformConfigForClient = (): PlatformMultiClientConfigForClient => {
  const key = (window.env.CLIENT || '') as MultiClientConfigKey;

  if (platformMultiClientConfigForClient[key]) {
    return platformMultiClientConfigForClient[key];
  }

  throw new Error(`Invalid client key: ${key}`);
};
